import { apiConfig } from 'config';
import { fetchDataInterceptor } from './FetchDataInterceptor';
import { handleErrorCause } from './HandleError';

export function getAlerts() {
  return fetchDataInterceptor(apiConfig.synthAlertsGet, {
    method: 'GET'
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function createAlert(data) {
  return fetchDataInterceptor(apiConfig.synthAlertsPost, {
    method: 'POST',
    body: JSON.stringify(data)
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function updateAlert(id, data) {
  return fetchDataInterceptor(apiConfig.synthAlertsPut(id), {
    method: 'PUT',
    body: JSON.stringify(data)
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function alertExport(id) {
  return fetchDataInterceptor(apiConfig.synthAlertsExport, {
    method: 'POST',
    body: JSON.stringify(id)
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function importAlert(JSONdata) {
  return fetchDataInterceptor(apiConfig.synthAlertsImport, {
    method: 'POST',
    body: JSONdata
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function deleteAlert(id) {
  return fetchDataInterceptor(apiConfig.synthAlertsDelete(id), {
    method: 'DELETE'
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function activateAlert(data) {
  return fetchDataInterceptor(apiConfig.synthAlertsToggleActivation, {
    method: 'POST',
    body: JSON.stringify(data)
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function duplicateAlert(data) {
  return fetchDataInterceptor(apiConfig.synthAlertsDuplicate, {
    method: 'POST',
    body: JSON.stringify(data)
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function getListAlertEvents(request) {
  const { id, searchText, limit, page, offset, tzOffset } = request;
  let url =
    apiConfig.synthAlertsGetListAlertEvents(id) + `?page=${page}&limit=${limit}&offset=${offset}&tzOffset=${tzOffset}`;
  if (searchText) {
    url += `&searchText=${searchText}`;
  }

  return fetchDataInterceptor(url, {
    method: 'GET'
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function polygonsGetData() {
  return fetchDataInterceptor(apiConfig.deviceGroupsSearchUserGroups + '?format=geo', {
    method: 'GET'
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function polygonsPivotsGetData(data) {
  return fetchDataInterceptor(apiConfig.cmServiceDevicesSearchV2, {
    method: 'POST',
    body: JSON.stringify(data)
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function getAlertRules() {
  return fetchDataInterceptor(apiConfig.synthAlertsGetAlertRules, {
    method: 'GET'
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function alertRulesGetConnectionInfo(id) {
  return fetchDataInterceptor(apiConfig.synthAlertsGetAlertRulesConnectionsInfo(id), {
    method: 'GET'
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function deleteAlertRules(id) {
  return fetchDataInterceptor(apiConfig.synthAlertsDeleteAlertRules(id), {
    method: 'DELETE'
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function getAlertRulesMetrics() {
  return fetchDataInterceptor(apiConfig.synthAlertsGetAlertRulesMetrics, {
    method: 'GET'
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function createRule(data) {
  return fetchDataInterceptor(apiConfig.synthAlertsPostAlertRules, {
    method: 'POST',
    body: JSON.stringify(data)
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function duplicateRule(data) {
  return fetchDataInterceptor(apiConfig.synthAlertsRulesDuplicate, {
    method: 'POST',
    body: JSON.stringify(data)
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function updateRule(id, data) {
  return fetchDataInterceptor(apiConfig.synthAlertsPutAlertRules(id), {
    method: 'PUT',
    body: JSON.stringify(data)
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function getAlertRulesShortInfo(id) {
  return fetchDataInterceptor(apiConfig.synthAlertsRulesGetShortInfo + '?polygonId=' + id, {
    method: 'GET'
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function searchPolygonsAndPivots(data) {
  return fetchDataInterceptor(apiConfig.synthAlertsSearchPolygonsAndPivots + '?searchText=' + data, {
    method: 'GET'
  }).catch((e) => {
    handleErrorCause(e);
  });
}

export function setCountOfViewedEvents({ id, lastViewedEventsTime }) {
  return fetchDataInterceptor(apiConfig.synthAlertsSetCountOfViewedEvents(id), {
    method: 'POST',
    body: JSON.stringify({ lastViewedEventsTime: lastViewedEventsTime })
  }).catch((e) => {
    handleErrorCause(e);
  });
}
